import { organisationConstants } from '../../_constants/organisation.constants';

const initialState = { assessor_loading : true, assessor_data: '', assessor_error: false};

export function groupReportAssessorList(state = initialState, action) {
    switch (action.type) {
        case organisationConstants.REQUEST_GROUP_REPORT_LIST_ASSESSOR:
            return {
                delOrgLoading: true,
                delOrgMessage: '',
                delOrgError: false
            };
        case organisationConstants.RECIEVE_GROUP_REPORT_LIST_ASSESSOR:
            return {
                delOrgLoading: false,
                delOrgMessage: action.assessorList,
                delOrgError: false
            }
        case organisationConstants.ERROR_GROUP_REPORT_LIST_ASSESSOR:
            return {
                delOrgLoading: false,
                delOrgMessage: '',
                delOrgError: true
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/groupReportAssessorList.reducer.js